export type SetNavigationStateAction = {
    type: 'setNavigationState';
    previousLocation: string | null;
    lastDashboardId: string | null;
};

export const setNavigationState = (
    previousLocation: string | null,
    lastDashboardId: string | null,
): SetNavigationStateAction => ({
    type: 'setNavigationState',
    previousLocation,
    lastDashboardId,
});

export type SetPreviousLocationAction = {
    type: 'setPreviousLocation';
    previousLocation: string | null;
};

export const setPreviousLocation = (previousLocation: string | null): SetPreviousLocationAction => ({
    type: 'setPreviousLocation',
    previousLocation,
});

export type SetLastDashboardIdAction = {
    type: 'setLastDashboardId';
    lastDashboardId: string | null;
};

export const setLastDashboardId = (lastDashboardId: string | null): SetLastDashboardIdAction => ({
    type: 'setLastDashboardId',
    lastDashboardId,
});

export type NavigationAction = SetNavigationStateAction | SetPreviousLocationAction | SetLastDashboardIdAction;
